import styled from "styled-components";

export const TextSuccess = styled.p`
color: #008000;
margin: 10px 0;
    font-size: 14px;
`